// Pure predicates for conversation polling decisions.
const TERMINAL_STATUSES = new Set(['complete', 'error'])
const PROCESSING_ROLES = new Set(['agent', 'system'])

// Returns true when the current user owns the ticket in a direct (non-grouped) conversation.
// "Grouped" for this purpose means active sub-agent child tickets — group_chat observers
// (e.g. admins with agent access) don't make the conversation multi-party.
export function isDirectOwnerInteraction(ticket, currentUserEmail) {
  if (!ticket || !currentUserEmail) return false
  const isAssigned = ticket.assigned_to === currentUserEmail
  const hasChildTickets = Array.isArray(ticket.child_tickets) && ticket.child_tickets.length > 0
  return isAssigned && !hasChildTickets
}

export function shouldPollConversation(ticket, currentUserEmail) {
  if (!ticket) return false

  const isComplete = TERMINAL_STATUSES.has(ticket.status)
  const isAssignedToMe = ticket.assigned_to === currentUserEmail
  const inGroupChat = Array.isArray(ticket.group_chat) && ticket.group_chat.includes(currentUserEmail)
  const isProcessing = PROCESSING_ROLES.has(ticket.role)
  const isGrouped =
    (Array.isArray(ticket.group_chat) && ticket.group_chat.length > 0) ||
    (Array.isArray(ticket.child_tickets) && ticket.child_tickets.length > 0)

  // 1. Grouped conversation — multiple humans and/or sub-agent threads.
  if (isGrouped) return true
  // 2. Watching someone else's active ticket.
  if (!isAssignedToMe && !inGroupChat && !isComplete) return true
  // 3. My ticket still being worked after the turn stream closed.
  if (isAssignedToMe && !isComplete && isProcessing) return true

  return false
}
